import styled from "@emotion/styled";
import { Button } from "../Button/Button";
import { Role } from "src/components/ContactCard/types";

const UnderlinedButtonStyle = styled(Button)`
  text-decoration: underline;
  text-underline-offset: 5px;
  padding: 0;
`;

const Row = styled.div`
  display: flex;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

interface RoleDict {
  UTILITY_BILL_CONTACT: Role;
  HOMEOWNER: Role;
  CONTRACT_SIGNER: Role;
  CONTRACT_COSIGNER: Role;
  OTHER: Role;
  BILLING: Role;
  DEPOSIT: Role;
  ACH: Role;
  CREDIT: Role;
  HOME_BUILDER: Role;
  CREDIT_CONTACT: Role;
}

const ROLE: RoleDict = {
  UTILITY_BILL_CONTACT: "UtilityBillContact",
  HOMEOWNER: "Homeowner",
  CONTRACT_SIGNER: "Contract Signer",
  CONTRACT_COSIGNER: "Contract Cosigner",
  OTHER: "Other",
  BILLING: "Billing",
  DEPOSIT: "Deposit",
  ACH: "ACH",
  CREDIT: "Credit",
  HOME_BUILDER: "Homebuilder",
  CREDIT_CONTACT: "Credit Contact",
};

export { Row, Col, UnderlinedButtonStyle, ROLE };
